var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"voice-dot-wrapper"},[_c('div',{staticClass:"voice-dot",class:{ mute: _vm.mute }},[_c('span',{style:(_vm.computedStyleObj_side)}),_c('span',{style:(_vm.computedStyleObj_middle)}),_c('span',{style:(_vm.computedStyleObj_side)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }